"use strict";
// Copyright 2019 Ryan Zeigler
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
/* istanbul ignore file */
var fp_ts_1 = require("fp-ts");
var l = __importStar(require("./list"));
var list_1 = require("./list");
var DequeueImpl = /** @class */ (function () {
    function DequeueImpl(front, back) {
        this.front = front;
        this.back = back;
    }
    DequeueImpl.prototype.take = function () {
        var _this = this;
        return l.cata(this.front, function (h, t) { return fp_ts_1.option.some([h, new DequeueImpl(t, _this.back)]); }, function () {
            return fp_ts_1.pipeable.pipe(_this.back, l.reverse, l.catac(function (h, t) { return fp_ts_1.option.some([h, new DequeueImpl(t, list_1.nil)]); }, function () { return fp_ts_1.option.none; }));
        });
    };
    DequeueImpl.prototype.offer = function (a) {
        return new DequeueImpl(this.front, list_1.cons(a, this.back));
    };
    DequeueImpl.prototype.pull = function () {
        var _this = this;
        return l.cata(this.back, function (h, t) { return fp_ts_1.option.some([h, new DequeueImpl(_this.front, t)]); }, function () {
            return fp_ts_1.pipeable.pipe(_this.front, l.reverse, l.catac(function (h, t) { return fp_ts_1.option.some([h, new DequeueImpl(list_1.nil, t)]); }, function () { return fp_ts_1.option.none; }));
        });
    };
    DequeueImpl.prototype.push = function (a) {
        return new DequeueImpl(list_1.cons(a, this.front), this.back);
    };
    DequeueImpl.prototype.filter = function (p) {
        return new DequeueImpl(l.filter(this.front, p), l.filter(this.back, p));
    };
    DequeueImpl.prototype.size = function () {
        return l.size(this.front) + l.size(this.back);
    };
    DequeueImpl.prototype.isEmpty = function () {
        return l.isEmpty(this.front) && l.isEmpty(this.back);
    };
    DequeueImpl.prototype.find = function (p) {
        var _this = this;
        return fp_ts_1.option.option.alt(l.find(this.front, p), function () { return l.find(_this.back, p); });
    };
    return DequeueImpl;
}());
function from(front, back) {
    return new DequeueImpl(front, back);
}
exports.from = from;
function empty() {
    return from(list_1.nil, list_1.nil);
}
exports.empty = empty;
function of(a) {
    return from(l.of(a), list_1.nil);
}
exports.of = of;
